import { config } from '@iheartjane/config';

import type { PosCart } from '@jane/shared/types';

import { api } from '../api/api';
import { createUseQueryHook } from '../utils/createUseQueryHook';

type GetPosCartReturnType = { pos_cart: PosCart | null };

const getPosCartUrl = (uuid: string) =>
  `${config.apiPath}/pos_cart?cart_uuid=${uuid}`;

const getPosCart = async (uuid?: string): Promise<PosCart | null> => {
  if (!uuid) {
    return null;
  }

  const url = getPosCartUrl(uuid);

  const result = await api.get<GetPosCartReturnType>(url);

  return result.pos_cart;
};

export const useGetPosCart = createUseQueryHook<string, PosCart | null>(
  getPosCart,
  (uuid: string) => ['posCart', uuid],
  (uuid) => !!uuid
);
